import React from 'react';
import { Field } from '../types';

/**
 * Recursively builds the JSON structure in "demo video" style.
 */
function buildDemoJson(fields: Field[]): any {
  let obj: any = {};
  fields.forEach((field) => {
    if (!field.key) return;
    if (field.type === 'nested') {
      obj[field.key] = buildDemoJson(field.children || []);
    } else if (field.type === 'string') {
      obj[field.key] = "STRING";
    } else if (field.type === 'number') {
      obj[field.key] = "number";
    }
  });
  return obj;
}

const JsonPreview: React.FC<{ schema: Field[] }> = ({ schema }) => (
  <pre
    style={{
      background: '#f7f7f7',
      borderRadius: 8,
      padding: 16,
      fontSize: 13,
      overflowX: 'auto',
      minHeight: 200,
    }}
  >
    {JSON.stringify(buildDemoJson(schema), null, 2)}
  </pre>
);

export default JsonPreview;
